import { createContext } from "react";

export const EmailVerifContext = createContext({
  client_email: "",
  isLoading: false,
  isConfirmationLoading: false,
  confirmCode: function (code: string) {},
  confirmationError: false,
  reinitialiseError: function () {},
});
